<template>
    <div class="wizard-step">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "WizardStep",
    data() {
        return {}
    },
}
</script>

<style lang="scss" scoped>
.wizard-step {


}
</style>
